import { Backdrop, Box, Grid, Typography } from "@mui/material";
import React, { Fragment } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { Slide } from "react-slideshow-image";
import styles from "./Album.module.css";
const indicators = (index: any) => <li className={styles.indicator}></li>;
const properties = {
  prevArrow: <ArrowBackIosRoundedIcon className={styles.arrow} />,
  nextArrow: <ArrowForwardIosRoundedIcon className={styles.arrow} />,
};
const Album: React.FC<{
  album: any;
  albumArray: any;
}> = (props) => {
  const [modal, setModal] = React.useState("");
  const handleClose = () => {
    setModal("");
  };
  const handleOpen = (event: any) => {
    setModal(event.target.id);
  };
  return (
    <Fragment>
      <Backdrop
        sx={(theme) => ({
          color: "#fff",
          zIndex: 10000,
        })}
        open={modal === "" ? false : true}
        // onClick={handleClose}
      >
        <Box
          sx={{
            backgroundColor: "white",
            width: { xs: "95vw", lg: "55rem" },
            // maxWidth: "80vh",
            // maxHeight: "100vh",
            height: "100vh",
            // height: { xs: "30rem", lg: "auto" },
            display: "flex",
            justifyContent: "space-between",
            // alignItems: "center",
            color: "black",
            py: { md: 5, xs: 2 },
            px: { md: 8, xs: 4 },
            position: "relative",
            flexDirection: "column",
            // zIndex: 1000000,
          }}
        >
          <button
            style={{
              position: "absolute",
              right: "1.5rem",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              top: "1.5rem",
            }}
            onClick={handleClose}
          >
            <ClearIcon />
          </button>

          <Typography component="h2" variant="h4">
            Album
          </Typography>
          <Typography>
            Explore a handpicked selection of our previously framed works.
          </Typography>
          <br />
          {props.album && modal && (
            <Slide
              slidesToScroll={1}
              // indicators={indicators}
              {...properties}
              // duration={}
              autoplay={false}
              transitionDuration={800}
              defaultIndex={Number(modal) - 1}
            >
              {props.albumArray.map((ind: any) => (
                <Box
                  sx={{
                    backgroundColor: "white",
                    padding: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "90vh",
                    // objectFit: "fill",
                    justifyContent: "center",
                    // zIndex: 10000000,
                  }}
                >
                  <img
                    src={props.album.get(`file${ind}`).url()}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      // aspectRatio: 1,
                      marginBottom: "1rem",
                      // maxWidth: "20rem",
                      cursor: "pointer",
                      objectFit: "contain",
                    }}
                    // id={String(ind)}
                    // onClick={handleOpen}
                  />
                </Box>
              ))}
            </Slide>
          )}
        </Box>
      </Backdrop>

      {props.album && props.album.get("counter") && props.albumArray.length && (
        <Grid
          container
          sx={{
            p: "1rem",
            // display: "flex",
            // flexDirection: "column",
            // justifyContent: "center",
            // alignItems: "center",
          }}
          spacing={2}
        >
          {props.albumArray.length < 3 ? (
            <Fragment>
              {props.albumArray.map((ind: number) => (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <img
                    src={props.album.get(`file${ind}`).url()}
                    alt=""
                    style={{
                      width: "100%",
                      aspectRatio: 1,
                      marginBottom: "1rem",
                      maxWidth: "20rem",
                      cursor: "pointer",
                    }}
                    id={String(ind)}
                    onClick={handleOpen}
                  />
                </Grid>
              ))}
            </Fragment>
          ) : props.albumArray.length < 5 ? (
            <Fragment>
              {props.albumArray.map((ind: number) => (
                <Grid
                  item
                  sm={5.5}
                  md={4}
                  lg={3}
                  sx={{ display: { xs: "none", sm: "block" } }}
                >
                  <img
                    src={props.album.get(`file${ind}`).url()}
                    alt=""
                    style={{
                      width: "100%",
                      aspectRatio: 1,
                      marginBottom: "1rem",
                      maxWidth: "20rem",
                      cursor: "pointer",
                    }}
                    id={String(ind)}
                    onClick={handleOpen}
                  />
                </Grid>
              ))}
            </Fragment>
          ) : props.albumArray.length < 7 ? (
            <Fragment>
              {props.albumArray.map((ind: number) => (
                <Grid
                  item
                  md={4}
                  lg={3}
                  sx={{ display: { xs: "none", md: "block" } }}
                >
                  <img
                    src={props.album.get(`file${ind}`).url()}
                    alt=""
                    style={{
                      width: "100%",
                      aspectRatio: 1,
                      marginBottom: "1rem",
                      maxWidth: "20rem",
                      cursor: "pointer",
                    }}
                    id={String(ind)}
                    onClick={handleOpen}
                  />
                </Grid>
              ))}
            </Fragment>
          ) : (
            props.albumArray.length < 9 && (
              <Fragment>
                {props.albumArray.map((ind: number) => (
                  <Grid
                    item
                    lg={3}
                    sx={{ display: { xs: "none", lg: "block" } }}
                  >
                    <img
                      src={props.album.get(`file${ind}`).url()}
                      alt=""
                      style={{
                        width: "100%",
                        aspectRatio: 1,
                        marginBottom: "1rem",
                        maxWidth: "20rem",
                        cursor: "pointer",
                      }}
                      id={String(ind)}
                      onClick={handleOpen}
                    />
                  </Grid>
                ))}
              </Fragment>
            )
          )}
        </Grid>
      )}
      {props.album &&
        props.album.get("counter") &&
        props.albumArray.length &&
        (window.screen.width > 1200
          ? props.albumArray.length > 8
          : window.screen.width > 900
          ? props.albumArray.length > 6
          : window.screen.width > 600
          ? props.albumArray.length > 4
          : props.albumArray.length > 2) && (
          <Slide
            slidesToScroll={1}
            slidesToShow={
              window.screen.width > 1200
                ? 4
                : window.screen.width > 900
                ? 3
                : window.screen.width > 600
                ? 2
                : 1
            }
            // indicators={indicators}
            {...properties}
            // duration={}
            autoplay={false}
            transitionDuration={800}
          >
            {props.albumArray
              .filter((num: number) => num % 2 === 1)
              .map((ind: number) => (
                <Box
                  sx={{
                    backgroundColor: "white",
                    padding: "1rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <img
                    src={props.album.get(`file${ind}`).url()}
                    alt=""
                    style={{
                      width: "100%",
                      aspectRatio: 1,
                      marginBottom: "1rem",
                      maxWidth: "20rem",
                      cursor: "pointer",
                    }}
                    id={String(ind)}
                    onClick={handleOpen}
                  />
                  {ind + 1 <= props.album.get("counter") ? (
                    <img
                      src={props.album.get(`file${ind + 1}`).url()}
                      alt=""
                      style={{
                        width: "100%",
                        aspectRatio: 1,
                        maxWidth: "20rem",
                        cursor: "pointer",
                      }}
                      id={String(ind + 1)}
                      onClick={handleOpen}
                    />
                  ) : (
                    <Box
                      sx={{
                        backgroundColor: "white",
                        width: "100%",
                        aspectRatio: 1,
                        maxWidth: "20rem",
                      }}
                    ></Box>
                  )}
                </Box>
              ))}
          </Slide>
        )}
    </Fragment>
  );
};

export default Album;
